import React from 'react';
import iconDrive from '../../../assets/icon-drive.svg';
import Button from '../../Button';
import { IntegrationTabStyle } from './IntegrationTab.styles';

const IntegrationTab = () => {
  return (
    <>
      <IntegrationTabStyle>
        <div className="holder">
          <strong className="title">Integrations</strong>
          <p>Connect AgentCy Labs with your existing tools.</p>
        </div>
        <div className="holder flex">
          <div className="text-box">
            <img className="icon" src={iconDrive} width="45" alt="img" />
            <strong className="title">Google Drive</strong>
            <p>Attach files from your Google Drive</p>
          </div>
          <Button width="100px" variant="secondary">
            Connect
          </Button>
        </div>
      </IntegrationTabStyle>
    </>
  );
};

export default IntegrationTab;
